import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { AdminLogHistoryParams, handleError } from 'api';
import { LogApiService } from 'features/log/api/log-api.services';
import qs from 'qs';

import { LogQueryKeys } from './query-keys';

const { getAdminVehicleLogHistory } = LogApiService();

const getUsersQuery = (
  params: AdminLogHistoryParams,
  options?: UseQueryOptions<any>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<any>;
  options?: UseQueryOptions<any>;
} => ({
  queryKey: LogQueryKeys.list(params),
  queryFn: ({ signal }) =>
    getAdminVehicleLogHistory(params, {
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetAdminVehicleLogList = (
  params: AdminLogHistoryParams,
  options?: UseQueryOptions<any>,
) => {
  const { message } = App.useApp();
     
  return useQuery<any, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};








